import React from "react"
import PropTypes from "prop-types"
import { Box } from "@mui/material"
import { grey } from "@mui/material/colors"
import GridCell from "./GridCell"
import FooterTextField from "./FooterTextField"
import { useModalPartida } from "hooks/modalPartida/useModalPartida"
import i18n from "i18n"
import { UNITS, MARGINS, TOTALS } from "constants/decimals"
import { useDecimalFormatter } from "hooks/useDecimalFormatter"

const RightFooterGrid = ({ currency, bancoDePrecios }) => {
  const {
    state,
    setMarginPercent,
    dispatchMarginPercent,
    dispatchUnitPrice,
    setUnitPrice,
    dispatchMarginEuro,
    setMarginEuro,
    dispatchDiscountPercentage,
    setDiscountPercentage,
  } = useModalPartida()

  const { getDecimals } = useDecimalFormatter()

  const locationPath = window.location.pathname.split("/")[1]

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        gridTemplateRows: "1fr 2fr 2fr",
        width: "100%",
        gap: "4px",
        paddingLeft: "2px",
        paddingRight: "4px",
        paddingBlock: "4px",
        backgroundColor: "#F6F7FB",
        borderBottomRightRadius: "10px",
      }}
    >
      <GridCell col="1 / 3" row="1 / 2" />
      <GridCell col="3 / 5" row="1 / 2">
        {i18n.t("footerGrid.commercialPrice")}
      </GridCell>

      <GridCell col="1 / 2" row="2">
        <FooterTextField
          value={state.rightFooter.marginPercent}
          decimalScale={getDecimals(MARGINS)}
          label={i18n.t("footerGrid.marginPercent")}
          disabled={!!bancoDePrecios}
          sx={{
            opacity: !!bancoDePrecios ? 0.2 : 1,
          }}
          onChange={dispatchMarginPercent}
          onBlur={setMarginPercent}
          suffix="%"
        />
      </GridCell>

      <GridCell col="2 / 3" row="2">
        <FooterTextField
          value={state.rightFooter.marginEuro}
          decimalScale={getDecimals(TOTALS)}
          label={i18n.t("footerGrid.margin")}
          onChange={dispatchMarginEuro}
          onBlur={setMarginEuro}
          suffix={currency}
          disabled={!!bancoDePrecios}
          sx={{
            opacity: !!bancoDePrecios ? 0.2 : 1,
          }}
        />
      </GridCell>

      <GridCell col="3 / 4" row="2">
        <FooterTextField
          label={i18n.t("footerGrid.unitPrice")}
          value={state.rightFooter.unitPrice}
          decimalScale={getDecimals(UNITS)}
          onChange={dispatchUnitPrice}
          onBlur={setUnitPrice}
          suffix={currency}
          disabled={!!bancoDePrecios}
          sx={{
            opacity: !!bancoDePrecios ? 0.2 : 1,
          }}
        />
      </GridCell>

      <GridCell col="4 / 5" row="2">
        <FooterTextField
          label={i18n.t("footerGrid.totalPrice")}
          decimalScale={getDecimals(TOTALS)}
          value={state.rightFooter.totalPrice}
          disabled
          suffix={currency}
          sx={{
            opacity: !!bancoDePrecios ? 0.2 : 1,
          }}
        />
      </GridCell>

      <GridCell col="1 / 2" row="3">
        <FooterTextField
          label={i18n.t("footerGrid.discountPercent")}
          value={state.rightFooter.discountPercentage}
          decimalScale={getDecimals(MARGINS)}
          onChange={dispatchDiscountPercentage}
          onBlur={setDiscountPercentage}
          disabled={!!bancoDePrecios}
          sx={{
            opacity: !!bancoDePrecios ? 0.2 : 1,
          }}
          suffix="%"
        />
      </GridCell>

      <GridCell col="2 / 3" row="3">
        <FooterTextField
          value={state.rightFooter.discountAmount}
          label={i18n.t("footerGrid.discount")}
          decimalScale={getDecimals(UNITS)}
          disabled
          suffix={currency}
          sx={{
            opacity: !!bancoDePrecios ? 0.2 : 1,
          }}
        />
      </GridCell>

      <GridCell col="3 / 4" row="3">
        <FooterTextField
          label={i18n.t("footerGrid.unitPriceWithDiscount")}
          value={state.rightFooter.unitPriceWithDiscount}
          decimalScale={getDecimals(UNITS)}
          disabled
          suffix={currency}
          sx={{
            opacity: !!bancoDePrecios ? 0.2 : 1,
          }}
        />
      </GridCell>

      <GridCell col="4 / 5" row="3">
        <FooterTextField
          label={i18n.t("footerGrid.totalWithDiscount")}
          value={state.rightFooter.totalPriceWithDiscount}
          decimalScale={getDecimals(TOTALS)}
          disabled
          suffix={currency}
          sx={{
            borderBottomRightRadius: "10px",
            opacity: !!bancoDePrecios ? 0.2 : 1,
          }}
        />
      </GridCell>
    </Box>
  )
}

RightFooterGrid.propTypes = {
  currency: PropTypes.string.isRequired,
  bancoDePrecios: PropTypes.string,
}

export default RightFooterGrid
